module.exports = __webpack_public_path__ + "img/xieshou-banner-home.e0417100.png";